import svgToTinyDataUri from '../svg-to-mini-data-uri';

export const refinanceCalculatorIcon = svgToTinyDataUri(
  `<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect x="8" y="4" width="32" height="40" rx="4" fill="var(--fill-0, #501283)"/>
  <rect x="12" y="8" width="24" height="10" rx="2" fill="#FFFFFF"/>
  <rect x="12" y="22" width="6" height="6" rx="1" fill="#FFFFFF"/>
  <rect x="21" y="22" width="6" height="6" rx="1" fill="#FFFFFF"/>
  <rect x="30" y="22" width="6" height="6" rx="1" fill="#FFFFFF"/>
  <rect x="12" y="32" width="6" height="6" rx="1" fill="#FFFFFF"/>
  <rect x="21" y="32" width="6" height="6" rx="1" fill="#FFFFFF"/>
  <rect x="30" y="32" width="6" height="6" rx="1" fill="#FFFFFF"/>
</svg>`,
);
